module.exports = __webpack_public_path__ + "static/img/icon-qrcode-ios.9da87679.png";